/**
 * 参戦シリーズ名称、クラス順位、出走台数からポイントを算出して表示する.
 *
 * @returns {void}
 */
const calculatePointsPreview = (): void => {
    document
        .querySelectorAll<HTMLInputElement>(".js-race-result-category")
        .forEach((categoryElement) => {
            categoryElement.addEventListener("change", (e) => {
                if (!(e.target instanceof HTMLInputElement)) return;
                if (!e.target.checked) return;

                calculatePoints();
            });
        });

    document.addEventListener("change", (e) => {
        const target = e.target as HTMLElement;

        if (
            target.matches(".js-race-result-series-name") ||
            target.matches(".js-race-result-class-rank") ||
            target.matches(".js-race-result-total-entries")
        ) {
            calculatePoints();
        }
    });

    // 初回表示.
    calculatePoints();
};

/**
 * ポイント算出本体.
 */
const calculatePoints = (): void => {
    const checkedCategory = document.querySelector<HTMLInputElement>(
        ".js-race-result-category:checked",
    );

    if (!checkedCategory) return;

    const activeItem = checkedCategory
        .closest(".js-race-result-container")
        ?.querySelector<HTMLElement>(".js-race-result-item");

    if (!activeItem) return;

    const seriesElement = activeItem.querySelector<
        HTMLInputElement | HTMLSelectElement
    >(".js-race-result-series-name");
    const rankElement = activeItem.querySelector<HTMLInputElement>(
        ".js-race-result-class-rank",
    );
    const totalEntriesElement = activeItem.querySelector<HTMLInputElement>(
        ".js-race-result-total-entries",
    );
    const previewElement =
        activeItem.querySelector<HTMLInputElement>(".js-points-preview");

    if (
        !seriesElement ||
        !rankElement ||
        !totalEntriesElement ||
        !previewElement
    )
        return;

    /**
     * entryRank = 「ポイントを持つ rank 名」
     * points.json のトップキーと一致する値
     */
    const entryRank =
        seriesElement instanceof HTMLSelectElement
            ? seriesElement.selectedOptions[0]?.dataset.entryRank
            : seriesElement.dataset.entryRank;

    if (!entryRank) {
        previewElement.value = "";
        return;
    }

    const rank = Number(rankElement.value);
    const totalEntries = Number(totalEntriesElement.value);

    // 入力不足時は未表示.
    if (!rank || !totalEntries) {
        previewElement.value = "";
        return;
    }

    const seriesTable = window.RACE_RESULT_POINTS[entryRank];
    if (!seriesTable) {
        previewElement.value = "";
        return;
    }

    /**
     * 出走台数区分の決定.
     */
    let entryType: "nolimit" | "high" | "mid" | "low" | null = null;

    // 台数制限なし.
    if ("nolimit" in seriesTable) {
        entryType = "nolimit";
    } else if (totalEntries >= 13) {
        entryType = "high";
    } else if (totalEntries >= 9) {
        entryType = "mid";
    } else if (totalEntries >= 4) {
        entryType = "low";
    } else {
        previewElement.value = "";
        return;
    }

    /**
     * ポイント取得
     * - 定義されていない順位は 0
     */
    const points = Number(seriesTable[entryType]?.[String(rank)] ?? 0);

    previewElement.value = `${points} ポイント`;
};

export default calculatePointsPreview;
